import React from "react";
import ReportForm from "./ReportForm.js";
import Image from "components/Elements/Image/Image.tsx";
import { useModal } from "../../../contexts/modalContext/modalContext.js";

import "./Report.scss";
import { useContent } from "contexts/contentContext/contentContext.js";

const ReportButton = () => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const setReport = () => setModal(ReportForm);

  return (
    <div className="report-button" onClick={setReport}>
      <Image className="report" name="report-flag" ext="png" alt="" />
      <div className="report-text">{getTextByKey("report-this-mail")}</div>
    </div>
  );
};

export default ReportButton;
